import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Image, Row } from 'react-bootstrap'
import { Card } from 'primereact/card';
import ReactApexChart from "react-apexcharts";
import TitleDashboard from '@components/general/Titles/TitleDashboard';
import { Animated } from 'react-animated-css';
import { Link } from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faClose, faDownload } from '@fortawesome/free-solid-svg-icons';
import RegistroUsuarios from './dashForoLectura/RegistroUsuarios';
import AvanceGeneral from './dashForoLectura/AvanceGeneral';
import { getAsesoresLectura, getPromedioGeneral, getUsuariosByFolio, validarAsesorLogeado } from '@helpers/httpRequests/httpRequestsGruposLectura/httpRequestsGruposLectura';
import { Typography } from '@mui/material';
import getUnixTimestamp from '@helpers/dates/getUnixTimestamp/getUnixTimestamp';
import getFechaSinHora from '@helpers/dates/getDateFinalizacionCurso/getFechaSinHora';


const DashForoLectura = ({ isTabActive, handleScrollToTop, folioGrupo, usuarioLogeado }) => {

    const [showRegistro, setShowRegistro] = useState(false);

    const [showAvance, setShowAvance] = useState(false);

    const [colaboradores, setColaboradores] = useState([]);

    const [promedioComprension, setPromedioComprension] = useState(0);

    const [promedioComprensionInicial, setPromedioComprensionInicial] = useState(0);

    const [promedioPpm, setPromedioPpm] = useState(0);

    const [promedioPpmInicial, setPromedioPpmInicial] = useState(0);

    const [cursosTerminados, setCursosTerminados] = useState(0);

    const [vistaPreviaReporte, setVistaPreviaReporte] = useState(false);

    //QUEDA POR OBTENER LAS CERTIFICACIONES DEL CURSO DE LECTURA INTELIGENTE CON EL FOLIO

    // Para calcular estos datos, se debe hacer una regla de 3 en base a la cantidad de usuarios que van en la semana 14 (645 x 100 / 2000 = 31.75% de progreso del curso)
    const progresoCurso = {
        series: [cursosTerminados, 100 - cursosTerminados],
        options: {
            chart: {
                type: "donut",
            },
            labels: ['% Terminado', '% Sin terminar'],
            colors: ['#19a13bff', '#83838393'],
            plotOptions: {
                pie: {
                    expandOnClick: false
                }
            }
        },


    }
    // Datos de ejemplo para la gráfica
    // Estos datos pueden ser validados dependiendo del numero de usuarios del grupo y de cuantos estan en la tabla alumnos_convenio con el folio del grupo/contrato.
    const usuariosRegistrados = {
        series: [colaboradores.length, usuarioLogeado.cantidadEstudiantesGrupo - colaboradores.length],
        options: {
            chart: {
                type: "donut",
            },
            labels: ['Registrados', 'Sin registrar'],
            colors: ['#ffcc00', '#83838393'],
            plotOptions: {
                pie: {
                    expandOnClick: false
                }
            }
        },


    }

    const configAvanceSemana = {
        series: [
            {
                name: "Terminadas",
                data: [10, 41, 35, 51, 49, 62, 69, 91, 148, 120, 130, 140, 150, 160].reverse(),
            },
        ],
        options: {
            colors: ["#ff9900"],
            chart: {
                type: "bar",
                height: 380,
                zoom: {
                    enabled: false,
                },
            },
            xaxis: {
                categories: ['Semana 1', 'Semana 2', 'Semana 3', 'Semana 4', 'Semana 5', 'Semana 6', 'Semana 7', 'Semana 8', 'Semana 9', 'Semana 10', 'Semana 11', 'Semana 12', 'Semana 13', 'Semana 14'],
            },

            tooltip: {
                x: {
                    formatter: function (val) {
                        return val;
                    },
                },
            },
        },
    };


    const footer = (
        <>

            {/* Desplega un table paginado con todos los usuarios registrados mostrando el detalle de su información */}
            <Button className="btn btn-primary" onClick={() => {
                setShowRegistro(true);
                handleScrollToTop();
            }}>Ver detalles</Button>

        </>
    );

    const footerAvance = (
        <>
            {/* Desplega un detallado paginado de los usuarios y sus estadísticas (ppm, su ultima leccion hecha, etc...) */}
            <Button className="btn btn-primary" onClick={() => {
                setShowAvance(true);
                handleScrollToTop();
            }}>Ver detalles</Button>

        </>
    );

    const [asesores, setAsesores] = useState([]);

    const [adminForo, setAdminForo] = useState(false);

    const [plantelActual, setPlantelActual] = useState('');

    const [docenteResponsable, setDocenteResponsable] = useState('');

    const obtenerUsuariosEmpresariales = async (esAdmin) => {
        try {
            console.log({ esAdmin })

            const { data } = await getUsuariosByFolio(usuarioLogeado.folioContrato);

            console.log("usuarios empresariales: ", data);

            let usuariosFiltrados = data;

            if (!esAdmin) {

                if (Array.isArray(data)) {
                    usuariosFiltrados = data.filter(data => data.correoDocente === usuarioLogeado.correo);
                    
                } else {
                    usuariosFiltrados = data.correoDocente === usuarioLogeado.correo ? data : [];
                    
                }
            }

            console.log(usuariosFiltrados);
            

            if (Array.isArray(usuariosFiltrados)) {
                setColaboradores(usuariosFiltrados);
                setDocenteResponsable(usuariosFiltrados[0].nombreDocente);
                setPlantelActual(usuariosFiltrados[0].plantel);
            } else {
                setColaboradores([usuariosFiltrados]);
                if (usuariosFiltrados.length > 0) {
                    setDocenteResponsable(usuariosFiltrados.nombreDocente);
                    setPlantelActual(usuariosFiltrados.plantel);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const descargarPDF = () => {

        try {
            const html2pdf = require('html2pdf.js');
            var element = document.getElementById('reporteForoLectura');
            html2pdf(element, {
                filename: `Reporte_empresarial_${getUnixTimestamp()}`
            });
        } catch (e) {
            console.log(e);
        }

    }
    useEffect(() => {

        const validarAsesor = async() => {
            try {
                await validarAsesorLogeado(usuarioLogeado.correo);
                setAdminForo(true);
                console.log('es un asesor registrado');
            } catch (error) {
                console.log('No se ha podido validar al asesor, no se encuentra registrado o hubo un error.')
            }
        }

        validarAsesor();

        const obtenerAsesor = async () => {
            try {
                const { data } = await getAsesoresLectura();

                console.log("ASESORES DEL GRUPO: ", data)


                if (Array.isArray(data)) {
                    setAsesores(data);
                } else {
                    setAsesores([data]);
                }
            } catch (error) {
                console.log(error);
            }
        };

        obtenerAsesor();


        const obtenerPromedioGeneralForo = async () => {
            try {
                const { data } = await getPromedioGeneral(folioGrupo);
                console.log(data);

                const { terminados } = data.cantTerminados;

                const porcentajeTerminados = ((terminados * 100) / 2000);
                console.log(porcentajeTerminados)

                setCursosTerminados(porcentajeTerminados);

                setPromedioComprension(data.promedio_comprension === null ? 0 : data.promedio_comprension);
                setPromedioComprensionInicial(data.promedio_comprension_inicial === null ? 0 : data.promedio_comprension_inicial);
                setPromedioPpm(data.promedio_ppm === null ? 0 : data.promedio_ppm);
                setPromedioPpmInicial(data.promedio_ppm_inicial === null ? 0 : data.promedio_ppm_inicial);

            } catch (error) {
                console.log('Error al obtener el promedio general: ', error);
            }
        }

        obtenerPromedioGeneralForo();
    }, [])

    useEffect(() => {
        obtenerUsuariosEmpresariales(adminForo);
    }, [adminForo])



    return (
        isTabActive && (
            <>

                {showRegistro ? (
                    <RegistroUsuarios usuarioLogeado={usuarioLogeado} adminForo={adminForo} colaboradores={colaboradores} setShowRegistro={setShowRegistro} />
                ) : null}


                {showAvance ? (
                    <AvanceGeneral usuarioLogeado={usuarioLogeado} adminForo={adminForo} colaboradores={colaboradores} setShowAvance={setShowAvance} />
                ) : null}

                {(!showRegistro && !showAvance && !vistaPreviaReporte) ? (
                    <Container fluid className="mb-5" style={{ minHeight: '50vh' }}>
                        <Row className="mt-4 justify-content-between">
                            <Col className='col-auto'>
                                <TitleDashboard title="Estadísticas" />
                            </Col>
                            {adminForo ? (
                                <Col className='col-auto'>
                                    <Button onClick={() => setVistaPreviaReporte(true)} className='btn btn-success'>Generar reporte</Button>
                                </Col>
                            ) : null}
                        </Row>
                        {(!adminForo && plantelActual !== "" && docenteResponsable !== "") && (
                            <Row className='mt-4'>
                                <Col>
                                    <p><b>Información del plantel:</b></p>
                                    <p>Docente Responsable: <b>{docenteResponsable}</b></p>
                                    <p>Plantel: <b>{plantelActual}</b></p>
                                </Col>
                            </Row>
                        )}

                        {adminForo && (
                            <Row className={`mt-4 justify-content-center d-flex flex-${!adminForo ? "row" : "column"} align-items-center gap-${!adminForo ? "0" : "4"}`}>
                                    <Col className="col-12">
                                        <div className="card">
                                            <Card title="Promedio general" style={{ minHeight: '200px' }}>
                                                <p>
                                                    Se inicia el curso con un promedio de palabras por minuto de <b>{promedioPpmInicial} ppm</b> y la comprension lectora es de <b>{promedioComprensionInicial}%</b>.
                                                </p>
                                                <p className="m-0">
                                                    Y actualmente el promedio de palabras por minuto es de <b>{Math.floor(promedioPpm)} ppm</b> y la comprension lectora es de <b>{Math.floor(promedioComprension)}%</b>.
                                                </p>
                                            </Card>
                                        </div>
                                    </Col>

                            </Row>
                        )}

                        {adminForo ? (
                            <Row className="mt-4">
                                    <Col className="col-12">
                                        <Row >
                                            <Col className="col-12 col-lg-6">
                                                <div className="card">
                                                    <Card title="Usuarios ya registrados">
                                                        <ReactApexChart options={usuariosRegistrados.options} series={usuariosRegistrados.series} type="donut" height="300" />
                                                    </Card>
                                                </div>
                                            </Col>
                                            <Col className="col-12 col-lg-6">
                                                <div className="card">
                                                    <Card title="Progreso del curso">
                                                        <ReactApexChart options={progresoCurso.options} series={progresoCurso.series} type="donut" height="300" />
                                                    </Card>
                                                </div>
                                            </Col>

                                            {/* <Col className="col-12 mt-4">
                                                <div className="card">
                                                <Card title="Seguimiento de los usuarios">
                                                    <ReactApexChart options={configAvanceSemana.options} series={configAvanceSemana.series} type="bar" height="350" />
                                                </Card>
                                            </div>
                                            </Col> */}
                                        </Row>
                                    </Col>
                            
                            </Row>
                        ) : null}
                        <Row className="mt-3">
                            <Col className={`col-12 col-lg-${!adminForo ? "6" : "6"}`}>
                                <div className="card">
                                    <Card title={`Usuarios registrados: ${colaboradores.length}`} footer={footer} style={{ minHeight: '250px' }}>
                                        <p className="m-0">
                                            Revisa cuántos usuarios se han registrado en el foro de lectura.
                                        </p>
                                    </Card>
                                </div>
                            </Col>

                            <Col className={`col-12 col-lg-${!adminForo ? "6" : "6"}`}>
                                <div className="card">
                                    <Card title="Avance general" footer={footerAvance} style={{ minHeight: '250px' }}>
                                        <p className="m-0">
                                            Mira el avance general de los usuarios registrados.
                                        </p>
                                    </Card>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                ) : null}

                {vistaPreviaReporte ? (
                    <Container className='p-5'>
                        <Row className='justify-content-end'>
                            <Col className='col-auto'>
                                <Button onClick={() => setVistaPreviaReporte(false)} className='btn btn-danger'><FontAwesomeIcon icon={faClose} color="white" /></Button>
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col className="col-auto mb-4 text-center">
                                <h3>Vista previa del reporte</h3>
                                <Button className={'btn-success'} onClick={descargarPDF}>Descargar <FontAwesomeIcon icon={faDownload} /> </Button>
                            </Col>
                        </Row>
                        
                        <Row style={{ border: '1px solid #212529', borderRadius: 15 }} className="mx-4 justify-content-center  shadow-lg">
                            <Col className="col-12 px-3" id="reporteForoLectura">

                                <Row className='mb-3'>
                                    <Col className="col-auto my-4">
                                        <Image src={require("@assets/images/logo-gc-horizontal.png")} width="175" />
                                    </Col>
                                    <Col className="col-auto my-4">
                                        <Image src={require("@assets/images/uvegActualizado.png")} width="175" />
                                    </Col>
                                </Row>

                                <Col className="col-12" style={{ marginBottom: 15 }}>
                                    <TitleDashboard title={"Reporte del Foro de Lectura Click+"} />

                                    <Row className="mt-4 mb-3">
                                        <Col>
                                            <h3 className='text-warning'>Promedio general</h3>
                                            
                                            <div className='mt-3'>

                                                <p>
                                                    Se inició el curso con un promedio de palabras por minuto de <b>{promedioPpmInicial} ppm</b> y una comprension lectora de <b>{promedioComprensionInicial}%</b>.
                                                </p>
                                                <p className="m-0">
                                                    Actualmente el promedio de palabras por minuto es de <b>{Math.floor(promedioPpm)} ppm</b> y la comprension lectora es de <b>{Math.floor(promedioComprension)}%</b>.
                                                </p>

                                            </div>


                                        </Col>
                                    </Row>

                                    <Row className="mt-4">
                                        <Col>
                                            <h3 className='text-warning'>Usuarios dentro del Foro de Lectura</h3>
                                            <div className='mt-3'>
                                                <p>Asesores registrados en el foro de lectura: <b>{asesores.length}</b></p>
                                                <p>Total de estudiantes que completaron su registro: <b>{colaboradores.length}</b></p>
                                            </div>

                                        </Col>
                                    </Row>
                                </Col>
                                <Row className='my-3'>
                                    <Col className="col-7">
                                        <Typography variant="h6">Usuarios ya registrados</Typography>
                                        <br />
                                        <Typography variant="caption">Gráfica que muestra el número de alumnos que completaron su registro en el curso.</Typography>
                                        <ReactApexChart options={usuariosRegistrados.options} series={usuariosRegistrados.series} type="donut" height="150" />

                                    </Col>

                                    <Col className="col-7" >
                                        <Typography variant="h6">Progreso del curso</Typography>
                                        <br />
                                        <Typography variant="caption">Gráfica que muestra el porcentaje de alumnos que ya completaron el curso de Lectura Inteligente.</Typography>

                                        <ReactApexChart options={progresoCurso.options} series={progresoCurso.series} type="donut" height="150" />
                                    </Col>

                                </Row>

                                <Row className='mt-3'>
                                    <Col className='text-center'>
                                        <p style={{color: 'gray'}}>Reporte generado el {getFechaSinHora(getUnixTimestamp())}</p>
                                    </Col>
                                </Row>


                            </Col>


                        </Row>
                    </Container>
                ): null}

            </>
        )
    )
}

export default DashForoLectura